<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Navigation -->
    <nav class="bg-white shadow-sm border-b">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex items-center">
            <router-link to="/" class="flex items-center space-x-3">
              <div class="flex-shrink-0">
                <img 
                  src="/images/logo.png" 
                  alt="SABIOLAB Logo" 
                  class="h-10 w-auto object-contain"
                >
              </div>
              <span class="text-xs text-gray-600 font-medium hidden sm:block border-l pl-3 border-gray-300">Plataforma Clinica Inteligente</span>
            </router-link>
          </div>
          <div class="flex items-center space-x-4">
            <template v-if="authStore.isAuthenticated">
              <!-- Usuario autenticado -->
              <UserProfileDropdown />
            </template>
            <template v-else>
              <!-- Usuario no autenticado - Solo mostrar botones de login en landing -->
            </template>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="bg-white border-t mt-12">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div class="text-center text-gray-500 text-sm">
          <p>&copy; 2025 SABIOLAB. Plataforma de Análisis Clínico de Alto Nivel.<br> powered by SABIODOC ®</p>
      <p class="text-sm text-gray-400 mt-2">
        Precisión diagnóstica respaldada por inteligencia artificial médica avanzada.
      </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useReportStore } from './stores/reportStore'
import { useAuthStore } from './stores/auth'
import UserProfileDropdown from './components/UserProfileDropdown.vue'

const reportStore = useReportStore()
const authStore = useAuthStore()

onMounted(() => {
  reportStore.initialize()
  // Verificar autenticación al cargar la app
  authStore.fetchProfile()
  // Manejar callback de OAuth
  authStore.handleOAuthCallback()
})
</script>

<style>
/* Global styles */
html {
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
